import * as THREE from 'three';

export default class Wall extends THREE.Mesh {
  constructor ({ width, height, depth, position, activeFace, colour }) {
    const paddleMaterial = new THREE.MeshLambertMaterial({color: colour});
    super(new THREE.BoxGeometry(width, height, depth), paddleMaterial);

    this.width= width;
    this.height = height;
    this.depth = depth;
    this.activeFace = activeFace;

    this.position.x = position.x;
    this.position.y = position.y;
    this.position.z = position.z;

    this.castShadow = true;
  }

  get left () {
    return this.position.x - (this.width / 2);
  }

  get right () {
    return this.position.x + (this.width / 2);
  }
}



// WEBPACK FOOTER //
// ./src/entities/wall.js